var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "landing-age-grid",
      class: `landing-age-grid_theme_${_vm.theme}`,
    },
    [
      _c(
        "div",
        { staticClass: "landing-age-grid__grid" },
        _vm._l(_vm.ageRanges, function (ageRange) {
          return _c(
            "div",
            {
              key: ageRange.value,
              staticClass: "landing-age-grid__item",
              class: { active: ageRange.value === _vm.activeValue },
              attrs: {
                "data-control": "button",
                "data-button-type": "age",
                "data-value": ageRange.value,
              },
              on: {
                click: function ($event) {
                  return _vm.onClick(ageRange)
                },
              },
            },
            [
              _c("img", {
                staticClass: "landing-age-grid__image",
                attrs: { src: ageRange.img, alt: "" },
              }),
              _c("div", { staticClass: "landing-age-grid__item-top" }),
              _c("div", { staticClass: "landing-age-grid__item-bottom" }, [
                _c("div", { staticClass: "landing-age-grid__item-text" }, [
                  _vm._v(_vm._s(ageRange.label)),
                ]),
                _c("div", { staticClass: "landing-age-grid__item-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "25",
                        height: "24",
                        viewBox: "0 0 25 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "12.1016",
                          cy: "12",
                          r: "10",
                          fill: "white",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.0736 12.0001C16.0736 12.4801 15.8836 12.9301 15.5436 13.2701L11.1736 17.6501C10.7036 18.1201 9.94359 18.1201 9.47359 17.6501C9.00359 17.1801 9.00359 16.4201 9.47359 15.9501L13.2136 12.2101C13.3336 12.0901 13.3336 11.9001 13.2136 11.7901L9.47359 8.05006C9.00359 7.58006 9.00359 6.82006 9.47359 6.35006C9.94359 5.88006 10.7036 5.88006 11.1736 6.35006L15.5436 10.7301C15.8836 11.0701 16.0736 11.5201 16.0736 12.0001Z",
                        },
                      }),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm.otherAgesButton
        ? _c("div", { staticClass: "landing-age-grid__other-ages" }, [
            _c(
              "button",
              {
                staticClass: "landing-age-grid__other-ages-button btn",
                attrs: {
                  type: "button",
                  "data-control": "button",
                  "data-button-type": "age",
                  "data-value": _vm.otherAgesButton.data.value,
                },
                on: {
                  click: function ($event) {
                    return _vm.onClick(_vm.otherAgesButton.data)
                  },
                },
              },
              [
                _c("span", [_vm._v(_vm._s(_vm.otherAgesButton.text))]),
                _c("i", { staticClass: "icon-arrow-right" }),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }